import { render, staticRenderFns } from "./LayoutShop.vue?vue&type=template&id=904df29c&scoped=true"
import script from "./LayoutShop.vue?vue&type=script&lang=ts"
export * from "./LayoutShop.vue?vue&type=script&lang=ts"
import style0 from "./LayoutShop.vue?vue&type=style&index=0&id=904df29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904df29c",
  null
  
)

export default component.exports